import { module } from "angular";
import { CancelButtonComponent } from "./CancelButtonComponent";

module("mmGui").component("irCancelButton", new CancelButtonComponent());
